module.exports = __webpack_public_path__ + "images/data8.png";